import { Workbook } from "exceljs"
import {exportDataGrid} from 'devextreme/excel_exporter';
import { saveAs } from "file-saver";
let exportRowIndex = 1; // Start from 1

export const onExporting = (e) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('main-sheet') 

    exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
          customizeCell: function (options) {
    const { gridCell, excelCell } = options;

    // Detect header row
    if (gridCell.rowType === 'header' && gridCell.column.dataField === 'rowIndex') {
      excelCell.value = 'ردیف'; // Or your Persian label
    }

    // Detect data rows and fill index manually
    if (gridCell.rowType === 'data' && gridCell.column.dataField === 'rowIndex') {
      excelCell.value = exportRowIndex; // Or just exportRowIndex
      exportRowIndex += 1;
    }

    // Optional styling
    excelCell.font = { name: 'Arial', size: 12 };
    excelCell.alignment = { horizontal: 'center' };
  }
    }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'data.xlsx')
        })
    })
}